import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b2be02a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "manageQuestionView" }

import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment/moment";
import { Question, QuestionControllerService } from "../../../backend/question";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageQuestionView',
  setup(__props) {

const tableRef = ref();

const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  userId: undefined,
  tags: [],
  title: "",
  pageSize: 10,
  current: 1,
  content: "",
});

const loadData = async () => {
  const res = await QuestionControllerService.listQuestionByPageUsingPost({
    ...searchParams.value,
    sortField: "createTime",
    sortOrder: "descend",
  });
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};
/**
 * 监听 searchParams 变量，改变时重新加载页面
 */
watchEffect(() => {
  loadData();
});

/**
 * 页面加载时，请求数据
 */
onMounted(() => {
  loadData();
});

const columns = [
  {
    title: "题号",
    slotName: "id",
    align: "center",
  },
  {
    title: "创建者",
    dataIndex: "userId",
    align: "center",
  },
  {
    title: "题目",
    dataIndex: "title",
    align: "center",
  },
  // {
  //   title: "内容",
  //   dataIndex: "content",
  //   align: "center",
  //   width: 250,
  // },
  {
    title: "标签",
    slotName: "tags",
    align: "center",
    width: 150,
  },
  // {
  //   title: "答案",
  //   dataIndex: "answer",
  //   align: "center",
  //   width: 150,
  // },
  {
    title: "提交数",
    dataIndex: "submitNum",
  },
  {
    title: "通过数",
    dataIndex: "acceptedNum",
  },
  {
    title: "题目要求",
    slotName: "judgeConfig",
    align: "center",
    width: 130,
  },
  {
    title: "判题用例",
    slotName: "judgeCase",
    align: "center",
    width: 120,
  },
  {
    title: "创建时间",
    slotName: "createTime",
    align: "center",
    width: 110,
  },
  {
    title: "操作",
    slotName: "optional",
    align: "center",
  },
];

/**
 * 分页
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 分页大小
 * @param size
 */
const onPageSizeChange = (size: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: size,
  };
};

/**
 * 删除
 * @param question
 */
const doDelete = async (question: Question) => {
  const res = await QuestionControllerService.deleteQuestionUsingPost({
    id: question.id,
  });
  if (res.code === 0) {
    message.success("删除成功");
    // todo 更新数据
    loadData();
  } else {
    message.error("删除失败");
  }
};
const router = useRouter();

/**
 * 跳转到做题页面
 * @param question
 */
const toQuestionPage = (questionId: number) => {
  console.log(questionId);
  router.push({
    path: `/question/view/${questionId}`,
  });
};

/**
 * 修改 / 更新操作
 * @param question
 */
const doUpdate = (question: Question) => {
  router.push({
    path: "/question/update",
    query: {
      id: question.id,
    },
  });
};

/**
 * 确认搜索，重新加载数据
 */
const doSubmit = () => {
  // 这里需要重置搜索页号
  searchParams.value = {
    ...searchParams.value,
    current: 1,
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline",
      style: {"justify-content":"center","align-content":"center","margin":"25px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "名称",
          tooltip: "请输入搜索的题目"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.title) = $event)),
              placeholder: "请输入题目名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "用户：",
          tooltip: "请输入用户的id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.userId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.userId) = $event)),
              placeholder: "请输入搜索用户"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "tags",
          label: "题目标签：",
          style: {"min-width":"280px"},
          tooltip: "请输入搜索题目标签"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: searchParams.value.tags,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.tags) = $event)),
              placeholder: "请输入题目标签"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "round",
              status: "normal",
              type: "outline",
              onClick: doSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      ref: tableRef.value,
      "column-resizable": true,
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
        showJumper: true,
        showPageSize: true,
      },
      onPageSizeChange: onPageSizeChange,
      onPageChange: onPageChange
    }, {
      id: _withCtx(({ record }) => [
        _createVNode(_component_a_link, {
          status: "normal",
          style: {"color":"blue"},
          onClick: ($event: any) => (toQuestionPage(record.id))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.id), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      tags: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(record.tags), (tag, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "cyan"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      judgeConfig: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(record.judgeConfig), (config, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "orangered"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`${
                index === "timeLimit"
                  ? "时间(ms)"
                  : index === "memoryLimit"
                  ? "内存(Kb)"
                  : "堆栈(Kb)"
              }`) + " " + _toDisplayString("：" + config), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      judgeCase: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(record.judgeCase), (config, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("示例" + _toDisplayString(index + 1) + ": 输入：" + _toDisplayString(config.input) + " ，输出：" + _toDisplayString(config.output), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "round",
              type: "outline",
              onClick: ($event: any) => (doUpdate(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("修改 ")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_popconfirm, {
              cancelText: "否",
              content: "确定要删除此题目吗?",
              okText: "是",
              type: "error",
              onCancel: _cache[3] || (_cache[3] = 
              () => {
                console.log(`已取消`);
              }
            ),
              onOk: ($event: any) => (doDelete(record))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  shape: "round",
                  status: "danger",
                  type: "outline"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除 ")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onOk"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})